import { axios } from "utils";

import { PUBLIC_ARTICLES_URL as endpoint } from "consts";

import { Article, ArticleCard, RATING_STATUS, UserAction } from "models";

export const getNewArticles = async (data?: { signal?: AbortSignal }): Promise<ArticleCard[]> => axios.get(`${endpoint}/new`, { data, signal: data?.signal });

export const getRecommendedArticles = async (data?: { signal?: AbortSignal }): Promise<ArticleCard[]> =>
  axios.get(`${endpoint}/recommended`, { data, signal: data?.signal });

export const getAllPosts = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/posts`, { data, signal: data.signal });

export const getFullArticle = async (data: { link: string; signal: AbortSignal }): Promise<Article> =>
  axios.get(`${endpoint}/${data.link}`, { data, signal: data.signal });

export const getArticlesByTag = async (data: { tag: string; signal: AbortSignal }) => axios.get(`${endpoint}/tags/${data.tag}`, { data, signal: data.signal });

export const getRelatedArticles = async (data: { link: string; signal: AbortSignal }): Promise<Article[]> =>
  axios.get(`${endpoint}/${data.link}/related`, { data, signal: data.signal });

export const getUserActionedArticleOrNews = async (data: { link: string; signal: AbortSignal }): Promise<UserAction> =>
  axios.get(`${endpoint}/${data.link}/user-actions`, { data, signal: data.signal });

export const saveArticleOrNews = async (data: { link: string; signal: AbortSignal }) =>
  axios.put(`${endpoint}/${data.link}/save`, { data, signal: data.signal });

export const rateArticle = async (data: { link: string; rating: RATING_STATUS; signal: AbortSignal }) =>
  axios.put(`${endpoint}/${data.link}/rating`, { data, signal: data.signal });
